import { render, staticRenderFns } from "./typography-text.vue?vue&type=template&id=57b753e8&scoped=true&"
import script from "./typography-text.vue?vue&type=script&lang=js&"
export * from "./typography-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b753e8",
  null
  
)

export default component.exports